/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatWorkspaceDomainPersona
 */
export interface ChatWorkspaceDomainPersona {
    /**
     * Unique identifier of the workspace domain persona
     * @type {string}
     * @memberof ChatWorkspaceDomainPersona
     */
    id: string;
    /**
     * Display name of the workspace domain
     * @type {string}
     * @memberof ChatWorkspaceDomainPersona
     */
    name: string;
    /**
     * URL of the workspace domain avatar image
     * @type {string}
     * @memberof ChatWorkspaceDomainPersona
     */
    avatarUrl: string;
    /**
     * The type discriminator for this persona
     * @type {string}
     * @memberof ChatWorkspaceDomainPersona
     */
    type: ChatWorkspaceDomainPersonaTypeEnum;
}


/**
 * @export
 */
export const ChatWorkspaceDomainPersonaTypeEnum = {
    ChatClientPersona: 'ChatClientPersona',
    ChatAgentPersona: 'ChatAgentPersona',
    WorkspacePersona: 'WorkspacePersona',
    ChatWorkspaceDomainPersona: 'ChatWorkspaceDomainPersona'
} as const;
export type ChatWorkspaceDomainPersonaTypeEnum = typeof ChatWorkspaceDomainPersonaTypeEnum[keyof typeof ChatWorkspaceDomainPersonaTypeEnum];


/**
 * Check if a given object implements the ChatWorkspaceDomainPersona interface.
 */
export function instanceOfChatWorkspaceDomainPersona(value: object): value is ChatWorkspaceDomainPersona {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ChatWorkspaceDomainPersonaFromJSON(json: any): ChatWorkspaceDomainPersona {
    return ChatWorkspaceDomainPersonaFromJSONTyped(json, false);
}

export function ChatWorkspaceDomainPersonaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatWorkspaceDomainPersona {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'avatarUrl': json['avatarUrl'],
        'type': json['type'],
    };
}

export function ChatWorkspaceDomainPersonaToJSON(json: any): ChatWorkspaceDomainPersona {
    return ChatWorkspaceDomainPersonaToJSONTyped(json, false);
}

export function ChatWorkspaceDomainPersonaToJSONTyped(value?: ChatWorkspaceDomainPersona | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'avatarUrl': value['avatarUrl'],
        'type': value['type'],
    };
}

